
/* Swipers */

const numbersSwiper = new Swiper(".numbersSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    breakpoints: {
        1200: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        860: {
            slidesPerView: 3.1,
            spaceBetween: 10,
        },
        550: {
            slidesPerView: 2.1,
            spaceBetween: 10,
        },
    },
});

const doctorsSwiper = new Swiper(".doctorsSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".doctors__swiper-button-next",
        prevEl: ".doctors__swiper-button-prev",
    },
    pagination: {
        el: ".doctors__swiper-pagination",
    },
    breakpoints: {
        1380: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
        1130: {
            slidesPerView: 4.1,
            spaceBetween: 20,
        },
        830: {
            slidesPerView: 3.1,
            spaceBetween: 10,
        },
        550: {
            slidesPerView: 2.1,
            spaceBetween: 10,
        },
    },
});

const licensesSwiper = new Swiper(".licensesSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".licenses__swiper-button-next",
        prevEl: ".licenses__swiper-button-prev",
    },
    pagination: {
        el: ".licenses__swiper-pagination",
    },
    breakpoints: {
        1320: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
        1130: {
            slidesPerView: 4.1,
            spaceBetween: 20,
        },
        830: {
            slidesPerView: 3.1,
            spaceBetween: 10,
        },
        550: {
            slidesPerView: 2.1,
            spaceBetween: 10,
        },
    },
});

const reviewsSwiper = new Swiper(".reviewsSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".reviews__swiper-button-next",
        prevEl: ".reviews__swiper-button-prev",
    },
    pagination: {
        el: ".reviews__swiper-pagination",
    },
    breakpoints: {
        1200: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 3.1,
            spaceBetween: 10,
        },
        560: {
            slidesPerView: 2.1,
            spaceBetween: 10,
        },
    },
});


const stocksSwiper = new Swiper(".stocksSwiper", {
    spaceBetween: 10,
    slidesPerView: 1.1,
    grid: {
      rows: 1,
    },
    navigation: {
        nextEl: ".stocks__swiper-button-next",
        prevEl: ".stocks__swiper-button-prev",
    },
    pagination: {
        el: ".stocks__swiper-pagination",
    },
    breakpoints: {
        1200: {
            slidesPerView: 2,
            spaceBetween: 20,
            grid: {
                rows: 2,
              },
        },
        600: {
            slidesPerView: 2.1,
            spaceBetween: 16,
            grid: {
                rows: 1,
              },
        },
    },
});






/* End swipers */